import { Route, Routes } from 'react-router-dom';
import { Box } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';

import { HeaderAndSideBar } from './common/component/blocks/HeaderAndSideBar';
import { Progress } from './common/component/parts/Progress';
import { LoginPage } from './login/component/page/LoginPage';
import { CurrentCarPlacePage } from './currentCarPlace/component/page/CurrentCarPlacePage';
import { EventVideoPage } from './eventVideo/component/page/EventVideoPage';
import { CarUseResultPage } from './carUseResult/component/page/CarUseResultPage';
import { NotFoundPage } from './common/component/page/NotFoundPage';
import { AlertDialog } from './common/component/parts/AlertDialog';

import { useStateUserInfo } from './common/component/hooks/useStateUserInfo';
import { useStateAsyncProcess } from './common/component/hooks/useStateAsyncProcess';
import { useStateDialog } from './common/component/hooks/useStateDialog';
import { useEffectGetSessionInfo } from './common/component/hooks/useEffectGetSessionInfo';
import { height, width } from './common/const/componentSize';
import { redirectToLogin } from './common/utils/redirectToLogin';

import theme from './theme';

/**
 * メインアプリ
 */
const App = () => {
	const { userInfo, setUserInfo } = useStateUserInfo(); // ログインユーザ情報の状態管理用カスタムフック
	const { isAsyncProcess, setIsAsyncProcess } = useStateAsyncProcess(); // ローディング表示の状態管理用カスタムフック
	const { dialog, setDialog, onCloseDialog } = useStateDialog(); // ダイアログ表示の状態管理用カスタムフック

	useEffectGetSessionInfo({ setDialog, setUserInfo }); // セッションデータの状態管理用カスタムフック

	// ブラウザバックを検知
	window.addEventListener('popstate', () => {
		if (location.pathname === '/login') {
			redirectToLogin();
		}
	});

	return (
		<ThemeProvider theme={theme}>
			<Box height={height} width={width}>
				{/* ヘッダーとサイドバー表示 */}
				<HeaderAndSideBar userInfo={userInfo} setUserInfo={setUserInfo} />
				{/* 各ページ表示 */}
				{!userInfo.isLogin && (
					<Routes>
						<Route path="/login" element={<LoginPage setUserInfo={setUserInfo} setIsAsyncProcess={setIsAsyncProcess} />} />
						<Route path="/*" element={<NotFoundPage />} />
					</Routes>
				)}
				{userInfo.isLogin && (
					<Routes>
						<Route path="/current-car-place" element={<CurrentCarPlacePage setIsAsyncProcess={setIsAsyncProcess} setDialog={setDialog} />} />
						<Route path="/car-use-result" element={<CarUseResultPage setIsAsyncProcess={setIsAsyncProcess} setDialog={setDialog} />} />
						<Route path="/event-video" element={<EventVideoPage setIsAsyncProcess={setIsAsyncProcess} setDialog={setDialog} />} />
						<Route path="/*" element={<NotFoundPage />} />
					</Routes>
				)}
				{/* ローディング表示 */}
				<Progress isAsyncProcess={isAsyncProcess} />
				{/* アラートダイアログ */}
				<AlertDialog dialog={dialog} onClose={onCloseDialog}></AlertDialog>
			</Box>
		</ThemeProvider>
	);
};

export default App;
